import React from 'react';
import { ListGroupItem } from "react-bootstrap";


const TimelineListThread = (props) => {
  const thread = props.thread;
  return (
    <ListGroupItem
      key={thread.threadId}
      onClick={() => props.clicked(thread)}
      header={thread._source.eventSubject}
    >
      {thread._source.eventFrom}
      <br></br>
      {"received: " + new Date(thread._source.appTimestamp).toLocaleString()}
    </ListGroupItem>
  )
}

export default TimelineListThread;


// WEBPACK FOOTER //
// ./src/containers/Timeline/TimelineListThread.js